/**
 * Lo que Twilio sólo muestra en su consola (Messaging Insights, Deliverability Score, Intelligent
 * Alerts; F19): no hay API, así que el producto no lo promete, lo nombra y manda a la consola.
 */

import { ExternalLink } from "lucide-react";
import { CONSOLA_TWILIO } from "../../logic/estadisticas";

export function TarjetaSoloConsola({ items }: { items: { titulo: string; detalle: string }[] | null | undefined }) {
  return (
    <div className="space-y-3">
      {!!items?.length && (
        <ul className="space-y-2">
          {items.map((i) => (
            <li key={i.titulo}>
              <p className="text-sm font-medium text-slate-800">{i.titulo}</p>
              <p className="text-xs text-slate-500">{i.detalle}</p>
            </li>
          ))}
        </ul>
      )}
      <a href={CONSOLA_TWILIO} target="_blank" rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3.5 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">
        Abrir la consola de Twilio <ExternalLink size={14} />
      </a>
    </div>
  );
}

export default TarjetaSoloConsola;
